import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pwa-install-ios-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
  ],
  templateUrl: './pwa-install-ios-dialog.component.html',
  styleUrls: ['./pwa-install-ios-dialog.component.scss'],
})
export class PwaInstallIosDialogComponent {
  constructor(public dialogRef: MatDialogRef<PwaInstallIosDialogComponent>) {}
}
